import "core-js/modules/es.array.push.js";
import axios from 'axios';
import Bus from '@/assets/js/bus.js';
import draggable from 'vuedraggable';
import Tool, { handleLocalStorage, returnSourceType, routerJump } from '@/assets/js/utils.js';
import AgoraClient from '@/assets/js/rtc-client-ng';
import VolumeBar from '@/assets/js/volumeBar.js';
import { mapState } from 'vuex';
import { controlDeviceBehavior, changeBehaviorStatus } from '@/assets/js/attendUser.js';
import cookie from 'js-cookie';
export default {
  computed: {
    ...mapState({
      State: state => state,
      nickNameMap: state => state.nickNameMap,
      loginInfo: state => state.loginInfo
    })
  },
  components: {
    draggable
  },
  data() {
    return {
      mic: true,
      speaker: true,
      partyInfo: {},
      talentSearch: '',
      talentList: [],
      allTalentList: [],
      // 用来在没有搜索时恢复全部显示
      talentTimer: null,
      stationSearch: '',
      stationList: [],
      allStationList: [],
      // 用来在没有搜索时恢复全部显示
      stationTimer: null,
      sessionList: [],
      rtc: null,
      rtcLoaded: false,
      channels: {},
      deviceType: {},
      devicesInfo: {},
      selectSessionInfo: {},
      noSessionSelectTalents: [],
      noSessionSelectStations: [],
      activeSpeakerInfo: {},
      repeatInfo: {
        show: false,
        title: 'common.repeatJoin',
        save: 'authorizeOperation.ok'
      },
      controlActiveTime: 0,
      selectStationInfo: [],
      partyCode: '',
      pressUpTime: 0,
      pressDownTime: 0,
      hostIsTalking: false,
      delayTimer: null,
      bindStationInfo: [],
      lastOperationTime: 0
    };
  },
  async created() {
    const {
      id
    } = this.$route.query;
    this.partyCode = id;
    window.addEventListener('keydown', this.listenEvent);
    if (!this.State.volumeBar) {
      this.State.volumeBar = new VolumeBar(async () => {
        this.rtc = new AgoraClient(this.AgoraCallBack);
        this.devicesInfo = await this.rtc.getDevice();
        this.getBindStation();
        this.joinParty(this.partyCode);
      });
    }
    Bus.$on('intercomPro', val => {
      var _val$sessionStationsL, _this$bindStationInfo;
      const {
        intercomSessionId,
        status,
        subModule,
        rtilCode,
        talk,
        sessionId,
        sessionName
      } = val;
      switch (subModule) {
        case 'intercomProSessionActive':
        case 'intercomProSessionInactive':
          this.asyncSessionActiveStatus(intercomSessionId, status);
          break;
        case 'intercomProAddStationsTalents':
          this.asyncSessionStationsTalents(val, 'add');
          break;
        case 'intercomProDelStationsTalents':
          this.asyncSessionStationsTalents(val, 'delete');
          break;
        case 'intercomProCreateSession':
          const newStationRtilCode = (_val$sessionStationsL = val.sessionStationsList[0]) === null || _val$sessionStationsL === void 0 ? void 0 : _val$sessionStationsL.rtilCode;
          if (newStationRtilCode == ((_this$bindStationInfo = this.bindStationInfo[0]) === null || _this$bindStationInfo === void 0 ? void 0 : _this$bindStationInfo.rtilCode)) this.sessionList.push(val);
          break;
        case 'intercomProDelSession':
          this.sessionList = this.sessionList.filter(item => item.intercomSessionId != sessionId);
          break;
        case 'intercomProUpdateSession':
          this.sessionList.forEach(item => {
            if (item.intercomSessionId == sessionId) {
              item.sessionName = sessionName;
            }
          });
          break;
        case 'intercomProPushToTalk':
          this.dealHostPushTalk(rtilCode, talk, intercomSessionId);
          break;
      }
    });
    Bus.$on('unbindStation', result => {
      const {
        email
      } = result;
      if (email == this.loginInfo.email) {
        routerJump('remove', {
          type: 'noCommonpartyPermission'
        });
      }
    });
  },
  methods: {
    getAllStation() {
      this.axios.get(`/partyline-backend/behavior/noLogin/getKeyList?partyCode=${this.partyInfo.joinCode}&key=addIntercomProDeviceRtilCode`).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          result.forEach(item => {
            const info = JSON.parse(item.value);
            const rtilCode = info.rtilCode;
            const deviceType = returnSourceType(info, info.sessionType);
            this.$set(this.nickNameMap, rtilCode, info.nickName);
            this.$set(this.deviceType, rtilCode, deviceType);
            if (deviceType == 'T' || deviceType === 'Talent') {
              const isHaveThis = this.talentList.find(talentItem => talentItem.rtilCode == rtilCode);
              if (!isHaveThis) {
                this.talentList.push({
                  ...info,
                  online: false
                });
                this.allTalentList.push({
                  ...info,
                  online: false
                });
              }
            } else {
              info.online = false;
              info.email = '';
              info.emailList = [];
              const isHaveThis = this.State.stationList.find(stationItem => stationItem.rtilCode == rtilCode);
              if (!isHaveThis) {
                this.stationList.push(info);
                this.allStationList.push(info);
                this.State.stationList.push(info);
              }
            }
          });
        }
      });
    },
    getBindStation() {
      this.axios.post('/partyline-backend/intercomPro/queryBindStation', {
        partyCode: this.partyCode
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          // 需要过滤返回的数据是否还在会议中
          const result = res.data.result;
          this.bindStationInfo = result;
          if (!result.length) routerJump('remove', {
            type: 'noCommonpartyPermission'
          });
        }
      });
    },
    asyncSessionActiveStatus(intercomSessionId, status) {
      if (status) {
        this.$message.success(this.$t('intercom.activeSession'));
      } else {
        // 如果当前取消 active 这个是选择的 session 并且还开着 pushtalk 则需要关闭 pushtalk
        this.$message.success(this.$t('intercom.deactiveSession'));
        if (intercomSessionId == this.selectSessionInfo.intercomSessionId && this.State.intercomPushTalk) {
          this.State.intercomPushTalk = false;
          this.sendPushTalk(false);
        }
      }
      this.sessionList.forEach(item => {
        if (item.intercomSessionId == intercomSessionId) {
          item.status = status;
        }
      });
    },
    asyncSessionStationsTalents(val, type) {
      const {
        intercomSessionId,
        sessionTalentsList,
        sessionStationsList
      } = val;
      // 如果 sessionTalentsList 有则是处理 talent 的
      const isAdd = type === 'add';
      const dealKey = sessionTalentsList ? 'sessionTalentsList' : 'sessionStationsList';
      const dealObject = sessionTalentsList || sessionStationsList;
      const rtilCode = dealObject[0].rtilCode;
      this.sessionList.forEach(item => {
        if (item.intercomSessionId == intercomSessionId) {
          if (isAdd) {
            if (dealKey === 'sessionTalentsList') {
              item.talentsRtilCodes.push(rtilCode);
            } else {
              item.stationsRtilCodes.push(rtilCode);
            }
            item[dealKey].push(dealObject[0]);
            // 如果当前正在处于 pushToTalk 的时候需要重新发送 pushtalk
            if (this.State.intercomPushTalk) {
              this.controlNewDeviceSubscribe(rtilCode, true);
            }
          } else {
            item[dealKey] = item[dealKey].filter(item1 => item1.rtilCode != dealObject[0].rtilCode);
            if (dealKey === 'sessionTalentsList') {
              item.talentsRtilCodes = item.talentsRtilCodes.filter(rtilCodes => rtilCodes != rtilCode);
            } else {
              item.stationsRtilCodes = item.stationsRtilCodes.filter(rtilCodes => rtilCodes != rtilCode);
            }
            if (this.State.intercomPushTalk) {
              this.controlNewDeviceSubscribe(rtilCode, false);
            }
          }
        }
      });
    },
    dealHostPushTalk(rtilCode, talk, intercomSessionId) {
      var _this$channels$rtilCo;
      talk ? this.$t('intercom.pushTalkToStation') : this.$t('intercom.pushTalkToStationEnd');
      const audioTrack = (_this$channels$rtilCo = this.channels[rtilCode]) === null || _this$channels$rtilCo === void 0 ? void 0 : _this$channels$rtilCo.audioTrack;
      this.sessionList.forEach(item => {
        if (item.intercomSessionId == intercomSessionId) item.pushToTalk = talk;
      });
      if (!audioTrack || !this.speaker) return;
      talk ? audioTrack.play(audioTrack, '', {
        type: 'audio'
      }) : audioTrack.stop();
    },
    listenEvent(event) {
      if (!this.sessionList.length) return;
      const key = event.key;
      switch (key) {
        case 'ArrowUp':
          // 首先判断是否有选中的 session
          if (this.selectSessionInfo.intercomSessionId) {
            const index = this.sessionList.findIndex(item => item.intercomSessionId == this.selectSessionInfo.intercomSessionId);
            if (index > 0) {
              this.selectSessionInfo = this.sessionList[index - 1];
            } else {
              this.selectSessionInfo = this.sessionList[this.sessionList.length - 1];
            }
          } else {
            this.selectSessionInfo = this.sessionList[this.sessionList.length - 1];
          }
          this.selectStationInfo = [];
          this.noSessionSelectTalents = [];
          this.noSessionSelectStations = [];
          break;
        case 'ArrowDown':
          if (this.selectSessionInfo.intercomSessionId) {
            const index = this.sessionList.findIndex(item => item.intercomSessionId == this.selectSessionInfo.intercomSessionId);
            if (index < this.sessionList.length - 1) {
              this.selectSessionInfo = this.sessionList[index + 1];
            } else {
              this.selectSessionInfo = this.sessionList[0];
            }
          } else {
            this.selectSessionInfo = this.sessionList[0];
          }
          this.selectStationInfo = [];
          this.noSessionSelectTalents = [];
          this.noSessionSelectStations = [];
          break;
      }
    },
    async checkEnv(partyCode) {
      if (!partyCode) return;
      const params = {
        partyCode,
        clientType: 0,
        memberId: this.loginInfo.id
      };
      this.axios.get('/partyline-backend/party/noLogin/checkV2', {
        params
      }).then(res => {
        const result = res.data.result;
        result.updateEnv = true;
        const cookieList = cookie.get();
        Object.keys(cookieList).forEach(key => {
          if (result.tagKey == key && result.tagValue == cookieList[key]) {
            result.updateEnv = false;
          }
        });
        result.tagList && result.tagList.forEach(v => {
          if (v.tagKey != result.tagKey || v.tagValue != result.tagValue) {
            Tool.setTagCookie(v.tagKey, v.tagValue, -1);
          }
        });
        Tool.setTagCookie(result.tagKey, result.tagValue);
        // 更新环境
        if (result.updateEnv) {
          window.location.reload();
        }
      });
    },
    getPartyInfo() {
      axios.get('/partyline-backend/intercomPro/get').then(async res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          await this.checkEnv(result.partyCode);
          Bus.$emit('changePartyAddress', {
            currentId: result.partyCode,
            lastId: result.id,
            init: 'initAside',
            title: result.title,
            id: result.id,
            createTime: result.createTime
          });
          Bus.$emit('updateInitStatus', {
            hasCopy: false
          });
          this.joinParty(result.partyCode);
        }
      });
    },
    joinParty(partyCode) {
      const params = {
        memberId: this.loginInfo.id || 'PL_' + new Date().getTime(),
        partyCode: partyCode,
        role: 0,
        type: 2,
        host: true,
        behaviorKeyList: ['speaker', 'nickName', 'mic']
      };
      axios.post('/partyline-backend/party/noLogin/join', params).then(async res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          const {
            mic,
            speaker
          } = result.behavior;
          this.partyInfo = result;
          this.State.partyJoinInfo = result;
          this.mic = mic !== 'false';
          this.speaker = speaker !== 'false';
          this.$set(this.State.nickNameMap, result.rtilCode, result.behavior.nickName);
          await this.checkEnv(result.partyCode);
          Bus.$emit('changePartyAddress', {
            currentId: result.joinCode,
            lastId: result.id,
            init: 'initAside',
            title: result.title,
            id: result.id,
            createTime: result.createTime
          });
          Bus.$emit('updateInitStatus', {
            hasCopy: false
          });
          this.getAllStation();
          this.getAllSession();
          this.createWebsocket(result);
          this.joinChannel(result);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    createWebsocket() {
      if (!this.State.pageSerBusRequestWs[this.partyCode]) {
        Bus.$emit('createWs', {
          ...this.State.config,
          partyCode: this.partyCode
        });
      }
    },
    async joinChannel(result) {
      const {
        appId,
        tokenCode,
        rtilCode,
        joinCode
      } = result;
      const params = {
        appId,
        channel: joinCode,
        token: tokenCode,
        uid: rtilCode,
        codec: 'h264',
        video: false,
        audio: true,
        subscribeRemote: false,
        // 默认不订阅
        microphoneId: this.devicesInfo.microphoneId
      };
      const uid = await this.rtc.join(params);
      if (uid) {
        this.rtcLoaded = true;
      }
    },
    AgoraCallBack({
      action,
      payload
    }) {
      const {
        id,
        mediaType
      } = payload;
      switch (action) {
        case 'user-joined':
          this.getDeviceDatailByRtilCode(payload);
          break;
        case 'user-published':
          if (mediaType === 'audio') {
            this.rtc.subscribe(id, 'audio');
          }
          break;
        case 'subscribe-track':
          this.subscribeTrack(payload);
          break;
        case 'user-left':
          this.leave(id);
          break;
        case 'connection-state-change':
          // 代表有人重复加入
          if (payload.reason === 'UID_BANNED') {
            this.repeatInfo.show = true;
          }
          break;
      }
    },
    getDeviceDatailByRtilCode(payload) {
      const {
        id,
        channel
      } = payload;
      if (!id || !channel) return;
      const params = {
        rtilCode: id,
        keys: ['nickName'],
        partyCode: this.partyInfo.joinCode
      };
      axios.post('/partyline-backend/receiver/noLogin/queryDeviceDetail', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          if (!result) return;
          const rtilCode = result.rtilCode;
          const deviceType = returnSourceType(result, result.sessionType);
          result.email = '';
          result.emailList = [];
          this.$set(this.nickNameMap, rtilCode, result.nickName);
          this.$set(this.deviceType, rtilCode, deviceType);
          switch (deviceType) {
            case 'App':
            case 'T':
            case 'Talent':
              const isHaveAddT = this.talentList.find(item => item.rtilCode == id);
              if (isHaveAddT) {
                isHaveAddT.online = true;
                return;
              }
              this.talentList.push({
                ...result,
                online: true
              });
              this.allTalentList.push(result);
              break;
            case 'R':
              const isHaveAddR = this.State.stationList.find(item => {
                return item.rtilCode == Number(id);
              });
              // 防止重复添加
              if (!isHaveAddR) {
                this.stationList.push(result);
                this.allStationList.push(result);
                this.State.stationList.push(result);
              }
              break;
          }
        }
      });
    },
    subscribeTrack(payload) {
      const {
        id,
        videoTrack,
        audioTrack
      } = payload;
      const obj = {
        id,
        videoTrack,
        audioTrack
      };
      this.$set(this.channels, id, obj);
      // 如果当前的 host 正在 pushtalk 则需要听见 host 声音
      // const hostRtilCode = this.partyInfo.managerRtils[0]
      // const hostHasPushTalk = this.sessionList.find(item => item.pushToTalk === 'true' && this.selectSessionInfo.intercomSessionId == item.intercomSessionId)
      // if (this.speaker && hostRtilCode == id && audioTrack && hostHasPushTalk) {
      //   this.sessionList.forEach(item => {
      //     if (item.pushToTalk === 'true') {
      //       audioTrack.play(audioTrack, '', { type: 'audio' })
      //     }
      //   })
      // }
    },

    footCallback(info) {
      const {
        type,
        val
      } = info;
      switch (type) {
        case 'controlAudio':
          this.mic = val;
          this.rtc.setEnabled(val, 'audio');
          const partyInfo = this.partyInfo;
          controlDeviceBehavior({
            senderRtilCode: partyInfo.rtilCode,
            type: 'mic',
            value: val,
            partyCode: partyInfo.joinCode,
            toRtilCode: partyInfo.rtilCode,
            origin: 'intercom',
            notChangeStatus: true
          });
          break;
        case 'controlSpeaker':
          this.speaker = val;
          this.State.speaker = val;
          changeBehaviorStatus({
            key: 'speaker',
            rtilCode: this.partyInfo.rtilCode,
            realPartyCode: this.partyInfo.joinCode,
            value: val
          });
          break;
        case 'changeDevice':
          this.switchDevice(val);
          break;
        case 'controlTalkToAllTalents':
          this.State.intercomTalkToAllTalents = val;
          this.sendTalkToAllTalents(val);
          break;
        case 'controlTalkToHost':
          this.State.intercomTalkToHost = val;
          this.sendTalkToHost(val);
          break;
        case 'changeNickName':
          this.$set(this.nickNameMap, this.partyInfo.rtilCode, val);
          break;
      }
    },
    contrlSessionTalk(item) {
      const isQuicklyOperation = this.isQuickluOperation();
      if (isQuicklyOperation || item.status != 1) return;
      item.pushToTalk = !item.pushToTalk;
      this.sendPushTalk(item, item.pushToTalk);
    },
    isQuickluOperation() {
      const currentTime = new Date().getTime();
      if (currentTime - this.lastOperationTime < 500) {
        return true;
      } else {
        this.lastOperationTime = currentTime;
        return false;
      }
    },
    switchDevice(info) {
      const {
        type,
        deviceId
      } = info;
      if (type === 'speaker') {
        handleLocalStorage('set', 'speakerId', deviceId);
      } else {
        this.rtc.setDevice(deviceId, type, result => {
          if (result === 'success') {
            this.$message.success(this.$t('common.switchMicSuccess'));
          } else {
            this.$message.warning(this.$t('common.switchMicFailed'));
          }
        });
      }
    },
    sendPushTalk(item, val) {
      const params = {
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: item.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        talentsRtilCodes: item.talentsRtilCodes,
        stationsRtilCodes: item.stationsRtilCodes,
        timestamp: new Date().getTime(),
        sessionName: item.sessionName
      };
      const url = val ? '/intercomPro/enablePushTalk' : '/intercomPro/disablePushTalk';
      this.axios.post(`/partyline-backend${url}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.savePushTalkBehavior(item, val);
        }
      });
    },
    savePushTalkBehavior(item, val) {
      if (!this.partyInfo.joinCode) return;
      const params = {
        userKkvs: [{
          module: 'setUserKkvs',
          key: 'pushToTalk',
          subKey: item.intercomSessionId,
          mark: this.partyInfo.rtilCode,
          value: val,
          annotation: this.partyInfo.joinCode,
          talentsRtilCodes: item.talentsRtilCodes,
          stationsRtilCodes: item.stationsRtilCodes,
          timestamp: new Date().getTime()
        }],
        annotation: this.partyInfo.joinCode
      };
      this.axios.post('/partyline-backend/userkkv/noLogin/setList', params).then(res => {});
    },
    sendTalkToAllTalents(val) {
      const params = {
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: this.selectSessionInfo.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        talentsRtilCodes: this.talentList.map(item => item.rtilCode) || [],
        timestamp: new Date().getTime()
      };
      const url = val ? '/intercomPro/enableTalkALL' : '/intercomPro/disableTalkALl';
      this.axios.post(`/partyline-backend${url}`, params).then(res => {
        this.saveTalkToAllTalentsBehavior(val);
      });
    },
    sendTalkToHost(val) {
      if (!this.selectSessionInfo.intercomSessionId) return;
      const params = {
        partyCode: this.partyInfo.joinCode,
        rtilCode: this.partyInfo.rtilCode,
        hostsRtilCodes: this.partyInfo.managerRtils,
        sessionName: this.selectSessionInfo.sessionName,
        intercomSessionId: this.selectSessionInfo.intercomSessionId
      };
      const url = val ? '/intercomPro/enablePushHost' : '/intercomPro/disablePushHost';
      this.axios.post(`/partyline-backend${url}`, params).then(res => {});
    },
    saveTalkToAllTalentsBehavior(val) {
      if (!this.partyInfo.joinCode) return;
      const params = {
        userKkvs: [{
          module: 'setUserKkvs',
          key: 'talkToAllTalent',
          subKey: 'talkToAllTalent',
          mark: this.partyInfo.rtilCode,
          value: val,
          annotation: this.partyInfo.joinCode,
          talentsRtilCodes: this.talentList.map(item => item.rtilCode) || [],
          timestamp: new Date().getTime()
        }],
        annotation: this.partyInfo.joinCode
      };
      this.axios.post('/partyline-backend/userkkv/noLogin/setList', params).then(res => {});
    },
    controlNewDeviceSubscribe(rtilCode, val) {
      const params = {
        partyCode: this.partyInfo.joinCode,
        targetRtilCodes: [rtilCode],
        startRtilCode: this.partyInfo.rtilCode,
        enable: val
      };
      this.axios.post('/partyline-backend/intercomPro/pushToTalk', params).then(res => {});
    },
    saveConnectRtilCode(item, type) {
      if (type === 'talent') {
        if (this.State.talentConnectRtilCode && item.rtilCode == this.State.talentConnectRtilCode) {
          this.State.talentConnectRtilCode = '';
          this.$set(this.borderColor, item.rtilCode, '');
        } else {
          this.State.talentConnectRtilCode = item.rtilCode;
          this.$set(this.borderColor, item.rtilCode, 'whiteColor');
        }
      } else {
        if (this.State.stationConnectRtilCode && item.rtilCode == this.State.stationConnectRtilCode) {
          this.State.stationConnectRtilCode = '';
          this.$set(this.borderColor, item.rtilCode, '');
        } else {
          this.State.stationConnectRtilCode = item.rtilCode;
          this.$set(this.borderColor, item.rtilCode, 'whiteColor');
        }
      }
    },
    getAllSession() {
      const params = {
        rtilCode: this.partyInfo.rtilCode,
        partyCode: this.partyInfo.joinCode
      };
      this.axios.post('/partyline-backend/intercomPro/queryStationSessionList', params).then(async res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          result.forEach(item => {
            item.sessionTalk = item.sessionTalk === 'true';
            item.pushToTalk = item.pushToTalk === 'true';
            item.showRenameInput = false;
            item.nameInputVal = '';
            item.talentsRtilCodes = item.sessionTalentsList.map(info => {
              return info.rtilCode;
            });
            item.stationsRtilCodes = item.sessionStationsList.map(info => {
              return info.rtilCode;
            });
          });
          this.sessionList = result;
          this.getPushTalkTalkAll();
        }
      });
    },
    getPushTalkTalkAll() {
      const params = {
        annotation: this.partyInfo.joinCode,
        keys: ['pushToTalk', 'talkToAllTalent'],
        subKeys: this.sessionList.map(item => item.intercomSessionId),
        marks: [this.partyInfo.rtilCode]
      };
      this.axios.post('/partyline-backend/userkkv/noLogin/getList', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          const localInfo = result[this.partyInfo.rtilCode];
          if (localInfo) {
            Object.keys(localInfo).forEach(key => {
              const itemInfo = localInfo[key];
              if (key === 'pushToTalk') {
                this.State.pushTalk = itemInfo.pushTalk === 'true';
              } else {
                this.State.intercomTalkToAllTalents = itemInfo.talkToAllTalent === 'true';
              }
            });
          }
        }
      });
    },
    delayTimeOperation(val, needDelayTime, callback) {
      const currentTime = new Date().getTime();
      val ? this.pressdownTime = currentTime : this.pressUpTime = currentTime;
      if (this.pressUpTime - this.pressdownTime < 500 && this.pressUpTime) {
        if (this.delayTimer) clearTimeout(this.delayTimer);
        this.pressdownTime = 0;
        this.pressUpTime = 0;
        this.$message.warning(this.$t('intercom.quicklyOperation'));
      } else {
        this.delayTimer = setTimeout(() => {
          if (callback) callback();
          this.pressdownTime = 0;
          this.pressUpTime = 0;
        }, needDelayTime);
      }
    },
    changeSessionList(val) {
      const currentMoveInfo = val.moved;
      const oldIndex = currentMoveInfo.oldIndex;
      const newIndex = currentMoveInfo.newIndex;
      const {
        sessionId,
        position
      } = this.caculateDragResult(oldIndex, newIndex);
      const params = {
        sessionId: currentMoveInfo.element.intercomSessionId,
        partyCode: this.partyInfo.joinCode,
        rank: {
          sessionId,
          position
        }
      };
      this.axios.post('/partyline-backend//intercomPro/updatePosition', params).then(res => {
        if (res.data.errorCode === '0x0') {}
      });
    },
    caculateDragResult(oldIndex, newIndex) {
      let sessionId = '';
      let position = '';
      if (oldIndex < newIndex) {
        sessionId = this.sessionList[newIndex + 1] ? this.sessionList[newIndex - 1].intercomSessionId : this.sessionList[this.sessionList.length - 2].intercomSessionId;
        position = 'AFTER';
      } else {
        sessionId = this.sessionList[newIndex - 1] ? sessionId = this.sessionList[newIndex + 1].intercomSessionId : this.sessionList[1].intercomSessionId;
        position = 'BEFORE';
      }
      return {
        sessionId,
        position
      };
    },
    saveSelectSessionInfo(item) {
      this.clearNoSessionInfo();
      if (this.selectSessionInfo.intercomSessionId === item.intercomSessionId) {
        this.selectSessionInfo = {};
      } else {
        this.selectSessionInfo = item;
        this.activeSpeakerInfo = item;
      }
    },
    showRenameInput(item) {
      item.showRenameInput = true;
      this.$nextTick(() => {
        const ref = this.$refs[item.intercomSessionId + '_input'];
        item.nameInputVal = item.sessionName;
        ref[0].$refs.input.focus();
        ref[0].$refs.input.select();
      });
    },
    saveSessionName(sessionName, item) {
      if (!sessionName) {
        this.$message.warning(this.$t('intercom.sessionNameEmpty'));
        return;
      }
      const params = {
        sessionId: item.intercomSessionId,
        sessionName,
        partyCode: this.partyInfo.joinCode
      };
      this.axios.post('/partyline-backend/intercomPro/updateSession', params).then(res => {
        if (res.data.errorCode === '0x0') {
          item.showRenameInput = false;
          item.sessionName = sessionName;
        }
      });
    },
    controlActive(item) {
      if (this.$route.name === 'station') return;
      const currentTime = new Date().getTime();
      if (currentTime - this.controlActiveTime < 1000) return;
      this.controlActiveTime = currentTime;
      this.selectSessionInfo = item;
      this.selectStationInfo = [];
      let activeSessionId = '';
      const haveActive = this.sessionList.filter(info => {
        if (info.status) activeSessionId = info.intercomSessionId;
        return info.status;
      });
      if (haveActive.length && item.intercomSessionId !== activeSessionId) {
        this.$message.warning(this.$t('intercom.onlyOneActive'));
        return;
      }
      if (!item.status && (!item.talentsRtilCodes.length || !item.stationsRtilCodes.length)) {
        this.$message.warning(this.$t('intercom.enableActiveFailed'));
        return;
      }
      const url = item.status ? '/partyline-backend/intercomPro/sessionInactive' : '/partyline-backend/intercomPro/sessionActive';
      item.status = item.status ? 0 : 1;
      this.selectSessionInfo.status = item.status;
      const params = {
        status: item.status,
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: item.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        talentsRtilCodes: item.sessionTalentsList.map(info => info.rtilCode),
        stationsRtilCodes: item.sessionStationsList.map(info => info.rtilCode)
      };
      this.axios.post(url, params).then(res => {
        if (res.data.errorCode !== '0x0') {
          item.status = params.status ? 0 : 1;
          this.selectSessionInfo.status = params.status ? 0 : 1;
        }
      }).catch(() => {
        item.status = params.status ? 0 : 1;
        this.selectSessionInfo.status = params.status ? 0 : 1;
      });
    },
    searchTalent(key) {
      if (this.talentTimer) clearTimeout(this.talentTimer);
      this.talentTimer = setTimeout(() => {
        if (key) {
          this.talentList = this.allTalentList.filter(item => item.nickName.includes(key));
        } else {
          this.talentList = this.allTalentList;
        }
      }, 800);
    },
    searchStation(key) {
      if (this.stationTimer) clearTimeout(this.stationTimer);
      this.stationTimer = setTimeout(() => {
        if (key) {
          this.stationList = this.allStationList.filter(item => item.nickName.includes(key));
        } else {
          this.stationList = this.allStationList;
        }
      }, 800);
    },
    showAllData(key) {
      key === 'talent' ? this.talentList = this.allTalentList : this.stationList = this.allStationList;
    },
    deleteSource(item, type) {
      if (!this.partyInfo.joinCode || this.$route.name === 'station') return;
      const currentSourceType = this.deviceType[item.rtilCode];
      if (currentSourceType === 'App') {
        this.deleteAppSource(item);
        return;
      }
      const params = {
        partyCode: this.partyInfo.joinCode,
        peerId: item.devicePeerId,
        type: 'device'
      };
      this.axios.delete('/partyline-backend/intercomPro/deviceRtilVoIP', {
        data: params
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('galleryHost.operationS'));
          if (type === 'talent') {
            this.sessionList.forEach(sessionInfo => {
              sessionInfo.talentsRtilCodes = sessionInfo.talentsRtilCodes.filter(rtilCode => rtilCode != item.rtilCode);
              sessionInfo.sessionTalentsList = sessionInfo.sessionTalentsList.filter(info => info.rtilCode != item.rtilCode);
            });
            this.talentList = this.talentList.filter(info => info.rtilCode != item.rtilCode);
          } else {
            this.sessionList.forEach(sessionInfo => {
              sessionInfo.stationsRtilCodes = sessionInfo.stationsRtilCodes.filter(rtilCode => rtilCode != item.rtilCode);
              sessionInfo.sessionStationsList = sessionInfo.sessionStationsList.filter(info => info.rtilCode != item.rtilCode);
            });
            this.stationList = this.stationList.filter(info => info.rtilCode != item.rtilCode);
          }
        }
      });
    },
    deleteAppSource(item) {
      const params = {
        partyCode: this.partyInfo.joinCode,
        rtilCode: item.rtilCode
      };
      this.axios.post(`/partyline-backend/partyAction/removeParticipant?partyCode=${this.partyInfo.joinCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.sessionList.forEach(sessionInfo => {
            sessionInfo.talentsRtilCodes = sessionInfo.talentsRtilCodes.filter(rtilCode => rtilCode != item.rtilCode);
            sessionInfo.sessionTalentsList = sessionInfo.sessionTalentsList.filter(info => info.rtilCode != item.rtilCode);
          });
          this.talentList = this.talentList.filter(info => info.rtilCode != item.rtilCode);
        }
      });
    },
    controlTalent(item) {
      if (this.$route.name === 'station') return;
      if (!this.selectSessionInfo.intercomSessionId) {
        const hasAddNoSessionArray = this.noSessionSelectTalents.filter(info => info.rtilCode === item.rtilCode);
        if (hasAddNoSessionArray.length) {
          this.noSessionSelectTalents = this.noSessionSelectTalents.filter(info => info.rtilCode !== item.rtilCode);
        } else {
          this.noSessionSelectTalents.push({
            rtilCode: item.rtilCode,
            peerId: item.devicePeerId
          });
        }
        return;
      }
      const params = {
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: this.selectSessionInfo.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        sessionTalentsList: [{
          rtilCode: item.rtilCode,
          peerId: item.devicePeerId
        }]
      };
      const isAddOperation = !this.selectSessionInfo.talentsRtilCodes.includes(item.rtilCode);
      const url = isAddOperation ? '/partyline-backend/intercomPro/addSessionStationsTalents' : '/partyline-backend/intercomPro/delSessionStationsTalents';
      this.axios.post(url, params).then(res => {
        if (res.data.errorCode === '0x0') {
          // 根据当前的 session 状态决定是否也要调更新接口
          if (this.selectSessionInfo.status == 1) {
            this.updateTalentList(item);
          }
          const sessionId = this.selectSessionInfo.intercomSessionId;
          // 把 session list 里面的数据更改调
          this.sessionList.forEach(info => {
            if (info.intercomSessionId == sessionId) {
              if (isAddOperation) {
                info.talentsRtilCodes.push(item.rtilCode);
                info.sessionTalentsList.push({
                  rtilCode: item.rtilCode,
                  peerId: item.devicePeerId
                });
              } else {
                info.talentsRtilCodes = info.talentsRtilCodes.filter(talent => talent != item.rtilCode);
                info.sessionTalentsList = info.sessionTalentsList.filter(talent => talent.rtilCode != item.rtilCode);
              }
            }
          });
        }
      });
    },
    updateTalentList(item) {
      const params = {
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: this.selectSessionInfo.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        talentsRtilCodes: [item.rtilCode]
      };
      const isAddOperation = !this.selectSessionInfo.talentsRtilCodes.includes(item.rtilCode);
      if (!isAddOperation) params.cid = this.selectSessionInfo.cid;
      const url = isAddOperation ? '/partyline-backend/intercomPro/incrementalActive' : '/partyline-backend/intercomPro/incrementalInactive';
      this.axios.post(url, params).then(res => {});
    },
    controlStation(item) {
      if (this.$route.name === 'station') return;
      if (!this.selectSessionInfo.intercomSessionId) {
        const hasAddNoSessionArray = this.noSessionSelectStations.filter(info => info.rtilCode === item.rtilCode);
        if (hasAddNoSessionArray.length) {
          this.noSessionSelectStations = this.noSessionSelectStations.filter(info => info.rtilCode !== item.rtilCode);
          const currentIndex = this.selectStationInfo.findIndex(info => info.rtilCode === item.rtilCode);
          this.selectStationInfo.forEach((item, index) => {
            if (index > currentIndex) {
              item.index += -1;
            }
          });
          this.selectStationInfo = this.selectStationInfo.filter(info => info.rtilCode != item.rtilCode);
        } else {
          this.noSessionSelectStations.push({
            rtilCode: item.rtilCode,
            peerId: item.devicePeerId
          });
          this.selectStationInfo.push({
            rtilCode: item.rtilCode,
            index: this.selectStationInfo.length + 1
          });
        }
        return;
      }
      if (this.selectSessionInfo.status === 1 && this.selectSessionInfo.stationsRtilCodes.length && !this.selectSessionInfo.stationsRtilCodes.includes(item.rtilCode)) {
        this.$message.warning(this.$t('intercom.cannotSwitchStation'));
        return;
      }
      const params = {
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: this.selectSessionInfo.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        sessionStationsList: [{
          rtilCode: item.rtilCode,
          peerId: item.devicePeerId
        }]
      };
      if (!this.selectSessionInfo.stationsRtilCodes.length) {
        this.addStation(params, item);
      } else if (this.selectSessionInfo.stationsRtilCodes.length && this.selectSessionInfo.stationsRtilCodes.includes(item.rtilCode)) {
        this.deleteStation(params, item);
      } else if (this.selectSessionInfo.stationsRtilCodes.length && !this.selectSessionInfo.stationsRtilCodes.includes(item.rtilCode)) {
        const deleteParams = JSON.parse(JSON.stringify(params));
        deleteParams.sessionStationsList[0].rtilCode = this.selectSessionInfo.stationsRtilCodes[0];
        deleteParams.sessionStationsList[0].peerId = this.selectSessionInfo.sessionStationsList[0].devicePeerId || this.selectSessionInfo.sessionStationsList[0].peerId;
        console.log(111111, JSON.stringify(params));
        this.deleteStation(deleteParams, {
          rtilCode: this.selectSessionInfo.stationsRtilCodes[0]
        });
        this.addStation(params, item);
      }
    },
    addStation(params, item) {
      this.axios.post('/partyline-backend/intercomPro/addSessionStationsTalents', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const sessionId = this.selectSessionInfo.intercomSessionId;
          this.sessionList.forEach(info => {
            if (info.intercomSessionId == sessionId) {
              info.stationsRtilCodes = [item.rtilCode];
              info.sessionStationsList = [item];
            }
          });
          // 如果当前处于 active 活跃状态需要再掉接口更新
          if (this.selectSessionInfo.status === 1) this.updateStationList(item, 'add');
        }
      });
    },
    deleteStation(params, item) {
      this.axios.post('/partyline-backend/intercomPro/delSessionStationsTalents', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const sessionId = this.selectSessionInfo.intercomSessionId;
          this.sessionList.forEach(info => {
            if (info.intercomSessionId == sessionId) {
              info.stationsRtilCodes = info.stationsRtilCodes.filter(rtilCode => rtilCode != item.rtilCode);
              info.sessionStationsList = info.sessionStationsList.filter(obj => obj.rtilCode != item.rtilCode);
            }
          });
          // 如果当前处于 active 活跃状态需要再掉接口更新
          if (this.selectSessionInfo.status === 1) this.updateStationList(item, 'delete');
        }
      });
    },
    updateStationList(item, key) {
      const params = {
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: this.selectSessionInfo.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        stationsRtilCodes: [item.rtilCode]
      };
      if (key === 'delete') params.cid = this.selectSessionInfo.cid;
      const url = key === 'add' ? '/partyline-backend/intercomPro/incrementalActive' : '/partyline-backend/intercomPro/incrementalInactive';
      this.axios.post(url, params).then(res => {});
    },
    returnTalentsName(item) {
      return item.sessionTalentsList.length ? item.sessionTalentsList.map(info => {
        return this.nickNameMap[info.rtilCode] || info.peerId;
      }).join(',') : '';
    },
    returnTalentSelect(item) {
      let flag = false;
      if (!this.selectSessionInfo.intercomSessionId) {
        this.noSessionSelectTalents.forEach(info => {
          if (info.rtilCode === item.rtilCode) flag = true;
        });
      } else {
        this.sessionList.forEach(sessionInfo => {
          if (sessionInfo.intercomSessionId === this.selectSessionInfo.intercomSessionId) {
            sessionInfo.sessionTalentsList.forEach(info => {
              if (info.rtilCode === item.rtilCode) flag = true;
            });
          }
        });
      }
      return flag;
    },
    returnSelectIndex(item) {
      let index = 1;
      this.selectStationInfo.findIndex(info => {
        if (info.rtilCode === item.rtilCode) {
          index = info.index;
        }
      });
      return index;
    },
    returnStationSelect(item, key) {
      let flag = false;
      if (key === 'session') {
        this.sessionList.forEach(sessionInfo => {
          if (sessionInfo.intercomSessionId === this.selectSessionInfo.intercomSessionId) {
            sessionInfo.sessionStationsList.forEach(info => {
              if (info.rtilCode === item.rtilCode) flag = true;
            });
          }
        });
      } else {
        this.noSessionSelectStations.forEach(info => {
          if (info.rtilCode === item.rtilCode) flag = true;
        });
      }
      return flag;
    },
    clearNoSessionInfo() {
      this.activeSpeakerInfo = {};
      this.selectStationInfo = [];
      this.noSessionSelectTalents = [];
      this.noSessionSelectStations = [];
    },
    leave(id) {
      this.talentList = this.talentList.filter(info => info.rtilCode != id);
      this.stationList = this.stationList.filter(info => info.rtilCode != id);
    }
  },
  beforeRouterLeave() {
    var _this$rtc;
    (_this$rtc = this.rtc) === null || _this$rtc === void 0 ? void 0 : _this$rtc.leave();
    window.removeEventListener(this.listenEvent);
  }
};